import { trans } from './bootstrap'

const Selectors = {
    Confirm: '[data-confirm]',
    ConfirmTitle: 'h3#confirm-title',
    ConfirmQuestion: 'span#confirm-question',
    ConfirmIconWrapper: 'div#confirm-icon',
    ConfirmIcon: 'div#confirm-icon > i',
    ConfirmButton: 'button[data-confirm-button]',
}

let confirmElement = document.getElementById('confirmModal')
if (confirmElement) {
    let defaultTitle = confirmElement.querySelector(Selectors.ConfirmTitle).innerHTML,
        defaultQuestion = confirmElement.querySelector(Selectors.ConfirmQuestion).outerHTML,
        confirmModal = new bootstrap.Modal(confirmElement),
        defaultIconWrapper = confirmElement.querySelector(Selectors.ConfirmIconWrapper).outerHTML,
        defaultButton = confirmElement.querySelector(Selectors.ConfirmButton).outerHTML

    confirmElement.addEventListener('show.bs.modal', event => {
        let target = event.relatedTarget,
            type = target.getAttribute('data-confirm') || 'default',
            color = target.getAttribute('data-confirm-color') || (type === 'delete' ? 'danger' : 'warning'),
            icon = target.getAttribute('data-confirm-icon') || (type === 'delete' ? 'bi-exclamation-octagon-fill' : 'bi-question-octagon-fill'),
            title = target.getAttribute('data-confirm-title') || (type === 'delete' ? trans.get('__JSON__.Confirm delete') : null),
            text = target.getAttribute('data-confirm-text') || trans.get('__JSON__.Are you sure?'),
            action = target.getAttribute('data-confirm-action') || null,
            url = target.getAttribute('href') || '#',
            button = target.getAttribute('data-confirm-button') || null

        confirmElement.querySelector(Selectors.ConfirmIconWrapper).classList.add(`bg-soft-${color}`)
        confirmElement.querySelector(Selectors.ConfirmIconWrapper).classList.add(`text-${color}`)
        confirmElement.querySelector(Selectors.ConfirmButton).classList.add(`btn-${color}`)
        confirmElement.querySelector(Selectors.ConfirmIcon).classList.add(icon)

        confirmElement.querySelector(Selectors.ConfirmQuestion).innerHTML = text
        if (title) confirmElement.querySelector(Selectors.ConfirmTitle).innerHTML = title
        if (button) confirmElement.querySelector(Selectors.ConfirmButton).innerHTML = button

        if (action) {
            confirmElement.querySelector(Selectors.ConfirmButton).onclick = () => new Function(action)()
            return
        }

        confirmElement.querySelector(Selectors.ConfirmButton).onclick = event => {
            window.axios({
                method: (type === 'delete') ? 'delete' : 'post',
                url,
            })
                .then(response => {
                    let data = response.data
                    if (data.redirect) window.location.href = data.redirect
                })
                .catch(error => confirm(error.response.data.message))
                .finally(() => confirmModal.hide())
        }
    })

    confirmElement.addEventListener('hidden.bs.modal', event => {
        confirmElement.querySelector(Selectors.ConfirmTitle).innerHTML = defaultTitle
        confirmElement.querySelector(Selectors.ConfirmQuestion).outerHTML = defaultQuestion
        confirmElement.querySelector(Selectors.ConfirmIconWrapper).outerHTML = defaultIconWrapper
        confirmElement.querySelector(Selectors.ConfirmButton).outerHTML = defaultButton
    })

    Array.from(document.querySelectorAll(Selectors.Confirm))
        .forEach(confirmNode => confirmNode.onclick = event => {
            event.preventDefault()
            confirmModal.show(confirmNode)
        })
}
